export default "__VITE_ASSET__BwJAIPc9__"